import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@gray/domain/http/api.service';

/** The coach's own notes about a student; the API scopes every call to the acting coach. */
@Injectable({providedIn: 'root'})
export class CoachStudentNoteService {

  private apiPrefix = '/coach/student-notes';

  constructor(
    private api: ApiService,
  ) {
  }

  getNotes(studentId: number, queryString = ''): Observable<any> {
    return this.api.get(`${this.apiPrefix}/students/${studentId}`, queryString);
  }

  createNote(studentId: number, content: string): Observable<any> {
    return this.api.post(`${this.apiPrefix}/students/${studentId}`, {content});
  }

  updateNote(noteId: number, content: string): Observable<any> {
    return this.api.patch(`${this.apiPrefix}/${noteId}`, {content});
  }

  deleteNote(noteId: number): Observable<any> {
    return this.api.delete(`${this.apiPrefix}/${noteId}`);
  }
}
